import { Button, Col, Form, Input, Row } from "antd";
import instance from "config/_axios";
import { FC, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useAppSelector } from "store/services";
import { asyncN } from "utils/notifications";
import { referenceModalType, subjectTopicReferenceType } from "./types";

const BasicLiterature: FC<referenceModalType> = ({ topicId, userId, data, refresh, setRefresh, closeModal }): JSX.Element => {
    const [form] = Form.useForm();
    const { t } = useTranslation()
    const auth: any = useAppSelector(state => state.auth);

    useEffect(() => {
        if (data) {
            form.setFieldsValue({
                ...data
            })
        }
    }, [data])

    const onFinish = async (values: any) => {
        try {
            let dataReq = new FormData();
            dataReq.append("name", values?.name);
            if (values?.link) dataReq.append("link", values?.link);
            dataReq.append("start_page", values?.start_page);
            dataReq.append("end_page", values?.end_page);
            dataReq.append("subject_topic_id", `${topicId}`);
            if (!auth?.user?.role?.includes("teacher")) {
                dataReq.append("user_id", `${userId}`);
            }
            dataReq.append("type", `2`);
            dataReq.append("status", `1`);
            const resp = await instance({
                url: `/subject-topic-references${data ? '/' + data?.id : ''}`,
                method: data ? 'put' : 'post',
                data: dataReq
            })
            if (resp?.data?.status === 1) {
                asyncN("success", data ? "update" : "create", resp?.data?.message).then(() => {
                    setRefresh(!refresh);
                    closeModal(false);
                    form.resetFields()
                })
            } else {
                asyncN("error", data ? "update" : "create", resp?.data?.message)
            }
        } catch (error: any) {
            asyncN("error", data ? "update" : "create", error?.response ? error?.response?.data?.message : error?.message)
        }
    }

    return (
        <Form layout="vertical" onFinish={onFinish} form={form}>
            <Row gutter={24}>
                <Col xs={24} sm={24} md={16} lg={16}>
                    <Form.Item label="Adabiyot nomi" rules={[{ required: true, message: "Please fill the field!" }]} name={'name'}>
                        <Input placeholder="Adabiyot nomi!" />
                    </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={8} lg={8}>
                    <Form.Item label="Adabiyot uchun giper havola" name={'link'}>
                        <Input onBlur={(e) => {
                            if (!(e.target?.value?.startsWith("http://") || e.target?.value?.startsWith("https://"))) {
                                form.setFields([
                                    { name: "link", errors: ["Input value not containing url link!"], validating: false }
                                ])
                            } else {
                                form.setFields([
                                    { name: "link", errors: [""], validating: true }
                                ])
                            }
                        }} type="text" placeholder="Adabiyot uchun havola!" />
                    </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={8} lg={8}>
                    <Form.Item label="Start page" rules={[{ required: true, message: "Please fill the field!" }]} name={'start_page'}>
                        <Input type="number" placeholder="Start page!" />
                    </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={8} lg={8}>
                    <Form.Item label="End page" rules={[{ required: true, message: "Please fill the field!" }]} name={'end_page'}>
                        <Input type="number" placeholder="End page!" />
                    </Form.Item>
                </Col>
                <Col className="d-f justify-content-end" span={24}>
                    <Button onClick={() => {
                        closeModal(false)
                        form.resetFields()
                    }} danger type="primary">{t("Cancel")}</Button>
                    <Button className="mx-1" htmlType="reset">{t("Reset")}</Button>
                    <Button type="primary" htmlType="submit">{t("Save")}</Button>
                </Col>
            </Row>
        </Form>
    )
}

export default BasicLiterature;